export const ACCOUNT_POLLING_INTERVAL = 11 * 1000;
export const PAPER_ACCOUNTS_POLLING_INTERVAL = 26 * 1000;
export const ORDERS_POLLING_INTERVAL = 30 * 1000;
export const POSITIONS_POLLING_INTERVAL = 10 * 1000;
export const MARGIN_POLLING_INTERVAL = 10 * 1000;
export const MARKET_STATUS_POLLING_INTERVAL = 60 * 1000;

export const ORDERBOOKS_POLLING_INTERVAL = 1 * 1000;
export const OPTION_CHAIN_SNAPSHOTS_POLLING_INTERVAL = 3 * 1000;
export const CRYPTO_SNAPSHOTS_POLLING_INTERVAL = 10 * 1000;
export const MARKET_DATA_POLLING_INTERVAL = 10 * 1000;
export const CLOCK_POLLING_INTERVAL = 60 * 1000;
export const TRADING_VIEW_POLLING_INTERVALS: Record<string, number> = {
  "1": 5 * 1000,
  "15": 30 * 1000,
  "30": 30 * 1000,
  "60": 60 * 1000,
};

export const ASSET_METADATA_STALE_TIME = 60 * 60 * 1000;
